export enum AppointmentBillableStatus {
  NOT_BILLABLE = 'NOT_BILLABLE',
  BILLABLE = 'BILLABLE',
}
